module.exports = __webpack_public_path__ + "static/img/volume-0.eb5c015f.svg";